import context from '../context';
import belongsToDayPart from './belongsToDayPart';

export default function shouldBeInOtherDayPartRow(event) {
  return !context.dayParts.some((dayPart) => belongsToDayPart(event, dayPart));
}
